import React  from 'react';
import { Avatar, Button } from '@nackle/paper';
import { profileUrl } from 'endpoints';
import { COMPANY_STORAGE_KEY } from '../../../../constants';
import { getShortName, getAvatarLogoColor } from 'utils/color';
import { LocaleString, getString } from '@nackle/intl-tools';
import { useDispatch, useSelector } from 'react-redux';

import {
	removeSelectedPeople,
	getIneligibleRecipients
} from 'app/app-dux/people-dux';

import './person-details.less';

export function PersonDetails( { person, additionalInfo = false, emailEnabled = true, size = 42, flow = '', changeRoute } ) {
	const companyId = localStorage.getItem( COMPANY_STORAGE_KEY );

	const dispatch = useDispatch();
	const ineligibleRecipients = useSelector( getIneligibleRecipients );

	const handlePeopleRemove = async ( event, person ) => {
		event.stopPropagation();
		await dispatch( removeSelectedPeople( person ) );
	};

	return (
		<div key={ `team-recipient=${ person.id }` } className={ ineligibleRecipients.includes( person.id ) ? 'recipient-item recipient-error' : 'recipient-item' }>
			<Avatar
				style={ getAvatarLogoColor( person ) }
				size={ size }
				src={ `${ profileUrl }/public/images/image/${ companyId }/${ person.id }/avatar` }
			>
				{ getShortName( person ) }
			</Avatar>
			<div className="recipient-error-block">
				<div className={ emailEnabled ? 'recipient-name-bold' : 'recipient-name' }>
					<div>
						{ `${ person.givenName } ${ person.surname }` }
					</div>
					<div className="recipient-additional-info">
						{ person?.personEmails?.length > 0 && emailEnabled &&
							<div className="recipient-email">
								{ person.personEmails[ 0 ].address }
							</div>
						}
						{ additionalInfo &&
							<div className="">
								{ person.country }
							</div>
						}
						{ flow && person?.awardValue > 0 &&
							<div className='recipient-points'>
								{ `${ person.awardValue } ${ getString( 'mediaLabel' ) }` }
							</div>
						}
						{ flow && ineligibleRecipients.includes( person.id ) &&
							<div className='text-danger'>
								<LocaleString code='recognition.error.ineligible' />
							</div>
						}
					</div>
					{
						flow &&
						<div>
							{ ineligibleRecipients.includes( person.id ) &&
								<Button
									style={ { marginLeft: 'auto' } }
									type='primary'
									danger
									onClick={ ( e ) => handlePeopleRemove( e, person ) }>
									<LocaleString code='recognition.button.remove'/>
								</Button>
							}
						</div>
					}
				</div>
			</div>
		</div>
	);
}